import React from 'react'
import Home from './Components/Javascript/home'

export default function homePage() {
  return (
    <div>
      <Home/>
    </div>
  )
}
